export const USER_PREFS_SCREEN_ID = "dispatch_list";

export const EMAIL_TRIAGE_SELECTED_FILTERS_STORAGE_KEY =
  "scnc_email_triage_selected_filters";

export const FILTER_LABEL_DISPLAY_OVERRIDES = {
  "Unit Code": "Site Code",
  "Item Code": "Material Code",
  "Item Description": "Material Description",
  "Supplier Inventory": "Supplier Inventory",
  "Bg": "BG",
  "Po Number": "PO Number",
  "No Of Day Delayed": "Delivery Deviation",
  "Source Identifier": "Information Source",
  "Dispatch Status": "Delivery Status",
  "Week" : "Shortage Week",
};

/** API `dispatch_status` filter values → friendly UI labels. */
export const DISPATCH_STATUS_VALUE_LABELS = {
  on_time: "On Time",
  preponed: "Preponed",
  delayed: "Delayed",
};

/** Display labels → API values for `dispatch_status` filters. */
export const DISPATCH_STATUS_DISPLAY_TO_API = {
  "On Time": "on_time",
  Preponed: "preponed",
  Delayed: "delayed",
};

export const FILTER_KEY_ORDER = [
  "po_number",
  "unit_code",
  "site_cluster",
  "vendor_name",
  "supplier_inventory",
  "material_code",
  "material_desc",
  "dispatch_status",
  "week",
  "no_of_day_delayed",
  "format",
  "bg",
];

export const DEFAULT_FAVOURITE_FILTER_KEYS = new Set([
  "unit_code",
  "site_cluster",
  "vendor_name",
  "material_code",
]);

export const PREF_FILTER_NAME_TO_KEY = {
  item_code: "material_code",
  item_description: "material_desc",
  supplier_inventory: "supplier_inventory",
};

export const FILTER_KEY_TO_PREF_NAME = {
  material_code: "item_code",
  material_desc: "item_description",
  supplier_inventory: "supplier_inventory",
};

export const PREF_COLUMN_NAME_TO_KEY = {
  action: "_action",
  no_of_day_delayed: "noOfDayDelayed",
};

export const COLUMN_KEY_TO_PREF_NAME = {
  _action: "action",
  noOfDayDelayed: "no_of_day_delayed",
};

/** Monitor Today: hide these columns even when returned by `/user-prefs`. */
export const EXCLUDED_DISPATCH_COLUMN_KEYS = new Set([
  "last_location",
  "distance_remaining",
]);

export const DISPATCH_COLUMNS = [
  { key: "srNo", label: "Sr No", sortType: "number" },
  { key: "poNumber", label: "PO Number", sortType: "string" },
  { key: "poLineItem", label: "PO Line Item", sortType: "string" },
  { key: "unitCode", label: "Site Code", sortType: "string" },
  { key: "siteCluster", label: "Site Cluster", sortType: "string" },
  { key: "vendorName", label: "Vendor Name", sortType: "string" },
  { key: "supplierInventory", label: "Supplier Inventory", sortType: "number" },
  { key: "materialCode", label: "Material Code", sortType: "string" },
  { key: "materialDescription", label: "Material Description", sortType: "string" },
  { key: "qtyPlanned", label: "PO Ordered Quantity", sortType: "number" },
  { key: "qtyAvailable", label: "Confirmed Dispatch Quantity", sortType: "number" },
  { key: "originalDispatchDate", label: "Expected Dispatch Date", sortType: "date" },
  { key: "originalDeliveryDate", label: "RDD", sortType: "date" },
  { key: "updatedDispatchDate", label: "Updated Dispatch Date", sortType: "date" },
  { key: "updatedDeliveryDate", label: "STA", sortType: "date" },
  { key: "dispatchStatus", label: "Delivery Status", sortType: "string" },
  { key: "noOfDayDelayed", label: "Delivery Deviation", sortType: "number" },
  { key: "eta", label: "Original ETA", sortType: "date" },
  { key: "rca", label: "Root Cause", sortType: "string" },
  { key: "shortageDate", label: "Shortage Date", sortType: "date" },
  { key: "transportationLt", label: "Transportation LT", sortType: "string" },
  { key: "trigger", label: "Trigger", sortType: "string" },
  { key: "format", label: "Format", sortType: "string" },
  { key: "bg", label: "BG", sortType: "string" },
  { key: "alertWeek", label: "Alert Week", sortType: "string" },
  { key: "alertId", label: "Alert Id", sortType: "string" },
  { key: "last_communication", label: "Last Communication/Changes", sortType: "string", sortable: false },
  { key: "_action", label: "Action", sortable: false },
  { key: 'source_identifier', label: "Information Source", sortType: "string" },
  { key: 'shortageDate', label: "Shortage Days", sortType: "string" },
  { key: 'updatedEta', label: "Revised ETA", sortType: "string" },
  { key: 'week', label: "Shortage Week", sortType: "string" }


];

export const DISPATCH_COLUMN_MAP = Object.fromEntries(
  DISPATCH_COLUMNS.map((c) => [c.key, c]),
);

export const DEFAULT_VISIBLE_COLUMNS = new Set([
  "srNo", "poNumber", "unitCode", "vendorName", "supplierInventory", "materialCode",
  "materialDescription", "qtyPlanned", "qtyAvailable",
  "originalDispatchDate", "originalDeliveryDate", "updatedDispatchDate",
  "updatedDeliveryDate", "dispatchStatus", "eta", "rca", "shortageDate",
  "alertId", "_action",
]);

export const STICKY_CLASS_MAP = {
  srNo: "sticky-col sticky-sr",
  _action: "sticky-col sticky-action",
};
